/**
 * Store-bound date-range editor for the Reserved Item Expiration filter option.
 */
import { observer } from "mobx-react";
import RmaListFiltersStore from "../../../../rma-list-page/stores/rma-list-filters-store";
import RmaListFilterDateRangeContent from "../../rma-list-filter-control/contents/date-range/rma-list-filter-date-range-content";

interface IProps {
    rmaListFiltersStore: RmaListFiltersStore;
    timeZone: string;
}

const ReservedItemDateRangeContent: React.FC<IProps> = observer(
    ({ rmaListFiltersStore, timeZone }) => {
        return (
            <RmaListFilterDateRangeContent
                embedded
                value={rmaListFiltersStore.reserveItemExpirationInput || ""}
                timeZone={timeZone}
                onChange={(isoRange) => {
                    rmaListFiltersStore.setReserverdItemExpirationInput(isoRange);
                }}
            />
        );
    },
);

export default ReservedItemDateRangeContent;
